export const socketConstants = {
  SOCKET_INIT: '[Socket] Init',
  SOCKET_INIT_ERROR: '[Socket] Init Error',
  SOCKET_SUBSCRIBE: '[Socket] Subscribe',
  SOCKET_UNSUBSCRIBE: '[Socket] Unsubscribe',
  SOCKET_EVENT: '[Socket] Event',
  SOCKET_EMIT: '[Socket] Emit'
}
